import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApiInterceptor } from './core/interceptor/api.interceptor';
// import { AuthService } from './auth/service/auth.service'; 
// import { LoaderComponent } from './shared/components/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { LanguageService } from './features/settings/language/service/language.service';
import { CommonDataService } from './core/services/common-data/common-data.service';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth/service/auth.service';
import { PublicService } from './core/services/shared-services/public/public.service';


Chart.register(...registerables, annotationPlugin);

export function multilableLanguageAPIInitializer() {
  
  return async () => {
    const languageService = inject(LanguageService);
    const commonData = inject(CommonDataService);
    const auth = inject(AuthService);  
    const publicConfig = inject(PublicService); 
    try {
      //call Public API :
      const response = await firstValueFrom(
        auth.getPublicConfig()
      );
      publicConfig.setPublicData(response);
    // Step 1: Get all languages list for dropdown
      const languageList: any = await firstValueFrom(languageService.getLanguageList());
      commonData.languages = languageList['labels'];

      let selectedLanguage:string | null = localStorage.getItem('selected_language') ? localStorage.getItem('selected_language') : 'ENGLISH'
      // Step 2: Get selected language details
      const languageResponse:any = await firstValueFrom(languageService.getLanguageDetails(selectedLanguage));
     commonData.language_data = languageResponse['labels'];

    }catch (error) {
      console.error('Error during app initialization:', error);
    }
  }
}



export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // provideHttpClient(),
    provideToastr(),
    // provideReactiveForms(),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    importProvidersFrom(NgSelectModule), // 👈 Global import of NgSelect
     provideAppInitializer(multilableLanguageAPIInitializer()), //Call API belore load the page
  ]
};
